export default __webpack_public_path__ + "static/media/011-Virtual glasses.fa514355.svg";